import React from 'react';
import * as GridTitle from '../../../constants/K007/GridTitle';
import * as ContextTitle from '../../../constants/K007/ContextSortTitle';

/**
 * MainGridTopRightDayOffTypeSlot
 */
class MainGridTopRightDayOffTypeSlot extends React.Component {

  render() {
    const usedMachinePriceDataUpdateFlag = this.props.usedMachinePriceDataUpdateFlag;

    const Nodes = GridTitle.GRID_TITLE_SLOT.map((item) => {
      let name = item.name;
      if (item.key == 'used_machine_price') {
        if (usedMachinePriceDataUpdateFlag == 1) {
          name += '(更新中)';
        }
      }

      if (this.props.dayFlg == '1' && !ContextTitle.MODEL_SORT_KEY.includes(item.key)) {

        if (this.props.sortKey == item.key) {
          if (this.props.sortOrder == "asc") {
            return (
              <div className="col ib border_r col_koumoku_header tab0 except_highlight textcenter col_sort trigger_context_sort_menu" key={item.id}>
                <span className="header_label_span">
                  {name}
                  <i className="sort_icon_asc_k007"></i>
                </span>
                <div className="sortColumnEvery" onClick={() => this.props.actions.clickDaySort(item.key, 'everyday')}></div>
                <div className="sortColumnWeek" onClick={() => this.props.actions.clickDaySort(item.key, 'weekday')}></div>
                <div className="sortColumnHoliday" onClick={() => this.props.actions.clickDaySort(item.key, 'holiday')}></div>
              </div>
            );

          } else {
            return (
              <div className="col ib border_r col_koumoku_header tab0 except_highlight textcenter col_sort trigger_context_sort_menu" key={item.id}>
                <span className="header_label_span">
                  {name}
                  <i className="sort_icon_desc_k007"></i>
                </span>
                <div className="sortColumnEvery" onClick={() => this.props.actions.clickDaySort(item.key, 'everyday')}></div>
                <div className="sortColumnWeek" onClick={() => this.props.actions.clickDaySort(item.key, 'weekday')}></div>
                <div className="sortColumnHoliday" onClick={() => this.props.actions.clickDaySort(item.key, 'holiday')}></div>
              </div>
            );

          }
        } else {
          return (
            <div className="col ib border_r col_koumoku_header tab0 except_highlight textcenter col_sort trigger_context_sort_menu" key={item.id} >
              <p className="nh">{name}</p>
              <div className="sortColumnEvery" onClick={() => this.props.actions.clickDaySort(item.key, 'everyday')}></div>
              <div className="sortColumnWeek" onClick={() => this.props.actions.clickDaySort(item.key, 'weekday')}></div>
              <div className="sortColumnHoliday" onClick={() => this.props.actions.clickDaySort(item.key, 'holiday')}></div>
            </div>
          );
        }
      } else {
        if (this.props.sortKey == item.key) {
          if (this.props.sortOrder == "asc") {
            return (
              <div className="col ib border_r col_koumoku_header tab0 except_highlight col_sort textcenter" key={item.id} onClick={() => this.props.actions.clickSort(item.key)}>
                <span className="header_label_span">
                  {name}
                  <i className="sort_icon_asc_k007"></i>
                </span>
              </div>
            );

          } else {
            return (
              <div className="col ib border_r col_koumoku_header tab0 except_highlight col_sort textcenter" key={item.id} onClick={() => this.props.actions.clickSort(item.key)}>
                <span className="header_label_span">
                  {name}
                  <i className="sort_icon_desc_k007"></i>
                </span>
              </div>
            );

          }
        } else {
          return (
            <div className="col ib border_r col_koumoku_header tab0 except_highlight col_sort textcenter" key={item.id} onClick={() => this.props.actions.clickSort(item.key)}>
              <p className="nh">{name}</p>
            </div>
          );
        }

      }

    });

    return (
      <div className="ledger_sheet_scroll return_x ib bar bar_y">
        <div className="ledger_sheet_scroll_inner scroll_x">
          <div className="modlue center_col ib">
            <div className="rowh sheet_header">
              {Nodes}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MainGridTopRightDayOffTypeSlot;
